'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useDictionary } from '@/core/hooks/use-dictionary';
import { MainShopProduct } from '@/core/models/shop-product-model';
import { Settings } from '@/core/models/settings-model';
import { formatPrice } from "@/utils/formatUtils"
import { Heading } from '../../../components/ui/Heading';
import { Badge } from '../../../components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../components/ui/tooltip';
import { getFabricInclusiveFinalPriceRial, getFabricInclusivePriceRial } from '../utils/productPriceExcerpt';

type FamilyProductCardProps = {
  product: MainShopProduct;
  settings?: Pick<Settings, 'discount_display_active' | 'fabric_rate_number' | 'vat_percentage'>;
};

export default function FamilyProductCard({ product, settings }: FamilyProductCardProps) {
  const { dictionary } = useDictionary();
  const inStock = product.inventory && product.inventory > 0;
  const hasDiscount = product.discount_percent > 0;
  const showDiscount = settings?.discount_display_active !== 'deactive';
  const fabricInclusivePrice = getFabricInclusivePriceRial(product, settings);
  const displayFinalPrice = getFabricInclusiveFinalPriceRial(product, settings);


  return (
    <Link
      href={`/shop/product/${product.id}/${product.slug}`}
      className="flex p-3"
    // style={{
    //   borderImageSlice: '4 4 4 4',
    //   borderImageWidth: '4px 4px 4px 4px',
    //   borderImageOutset: '.5px .5px .5px .5px',
    //   borderImageRepeat: 'round round',
    //   borderImageSource: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB3SURBVHgB7dVBCoAgFEXR911JjcRVVSurXamj2on5wiCkWd9RnpkiF0FRCSEkZCKyWWsXPHjvhzy/o5JSGp1zR7V2y2una3BHtbBnuEMo0u51Ba8NFLFn3u7hF+wZNPD3KB8HKNLudUWMcYUi9nj6MxSxJy3+qBOdU0PNJhRu4gAAAABJRU5ErkJggg==)',
    //   borderStyle: 'solid',
    //   imageRendering: 'pixelated'
    // }}
    >
      <div className="relative aspect-square h-44 shrink-0 rounded-lg overflow-hidden bg-primary-0">
        <Image
          src={product.thumbnail.url}
          alt={product.title}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 25vw"
          className="object-contain"
          priority
        />
        {hasDiscount && showDiscount && <Badge variant="destructive" className="absolute top-2 right-2 ltr:left-2 text-xs rounded-xs">
          {product.discount_percent + "% " + product.discount_title}
        </Badge>}
        {!inStock ? <Badge variant="secondary" className="absolute top-2 left-2 ltr:right-2 text-xs rounded-xs">
          {dictionary.ui?.product.noInventory}
        </Badge> : ""}
      </div>

      <div className="flex items-center space-y-2 px-4 min-w-0 flex-1">
        <div className='flex flex-col space-y-2 min-w-0 w-full'>

          <Heading level={3} className="text-xs break-words">
            {product.title}
          </Heading>
          <div className="space-y-1">
            {Number(product.price) === 0 || Number(product.final_price) === 0 ? (
              <p className="text-xs font-medium text-blue-600">{dictionary.ui.form.contactus}</p>
            ) :
              hasDiscount && showDiscount ? (
                <div className="flex flex-col items-end space-y-0.5">
                  <span className="text-xs text-red-500 line-through">
                    {formatPrice(fabricInclusivePrice)} {dictionary.ui.product.currency}
                  </span>
                  <span className="text-primary-600 text-xs">
                    {formatPrice(displayFinalPrice)} {dictionary.ui.product.currency}
                  </span>
                </div>
              ) : (
                <span className="text-primary-600 text-xs">
                  {formatPrice(fabricInclusivePrice)} {dictionary.ui.product.currency}
                </span>
              )}
          </div>
        </div>

        {/* {!!product.product_colors && <div className="flex flex-wrap gap-3">
          {product.product_colors.map((color, index) => (
            <Tooltip key={index}>
              <TooltipTrigger asChild>
                <span>
                  <div
                    className="size-4 rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110"
                    style={{ backgroundColor: color.color_code_hex }}
                    title={color.color_title}
                  />
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm text-primary-0">{color.color_title}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </div>} */}
      </div>
    </Link >
  );
}